import React, {Component} from "react";
import PropTypes from "prop-types";

import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import TextField from '@material-ui/core/TextField';
import {saveAs} from 'file-saver';

import {withStyles} from "@material-ui/core/styles";

import {parseGpx, buildTcx} from "../gpxToTcx";

const styles = theme => ({
  homeRoot: {
  },
  homeRootFull: {
    top: 0,
    [theme.breakpoints.up("sm")]: {
      top: 0,
    },
  },
  greetings: {
    padding: "8px",
    margin: "8px",
    height: "calc(100% - 32px)",
  },

  wrapper: {
    position: "absolute",
    left: 0,
    bottom: 0,
    right: 0,
    top: 0,
    zIndex: 100,

    padding: "15px",
    textAlign: "left",
  },

  buttons: {
    marginLeft: 10,
  },

  error: {
    color: "red",
  },

  summary: {
    marginTop: 10,
  },

  hidden: {
    display: "none",
  },

});

const i18n = {
  'ru': {
    'title': 'Конвертация GPX в TCX для Wahoo',
    'description': 'Точки (waypoints) из GPX файла превращаются в точки маршрута (course points) TCX файла. Wahoo ELEMNT будет показывать ваши точки вместо автоматических «Поверните налево», «Поверните направо» и т.д.',
    'route_title': 'Название маршрута',
    'summary': (trackCount, waypointCount) => `Точек трека: ${trackCount}, точек интереса: ${waypointCount}`,
    'convert': 'Конвертировать для Wahoo',
    'error_no_trk': 'В GPX файле не найден <trk>',
    'error_no_trkseg': 'В GPX файле не найден <trkseg>',
    'error_few_trkpt': 'В треке должно быть минимум 2 точки <trkpt>',
  },
  'en': {
    'title': 'Convert GPX file to TCX for Wahoo',
    'description': 'GPX waypoints are converted into TCX course points, so Wahoo ELEMNT shows your own points instead of auto-generated "Turn Left", "Turn Right", etc.',
    'route_title': 'Route Title',
    'summary': (trackCount, waypointCount) => `Trackpoints: ${trackCount}, waypoints: ${waypointCount}`,
    'convert': 'Convert For Wahoo',
    'error_no_trk': 'No <trk> found in GPX',
    'error_no_trkseg': 'No <trkseg> found in GPX',
    'error_few_trkpt': 'Track must contain at least 2 <trkpt> elements',
  },
};




class Home extends Component {

  state = {
    gpxFile: null,
    courseName: null,
    isCourseNameEditable: false,
    gpxData: null,
    error: null,
  }

  getI18n = (text_title) => {
    let key = 'ru';
    if (this.props.match.path.startsWith('/en/')) {
      key = 'en';
    }
    return i18n[key][text_title];
  }

  getErrorText = (error) => {
    const translated = error.code && this.getI18n(`error_${error.code}`);
    return translated || error.message;
  }

  onFileChange = e => {
    const files = Array.from(e.target.files);
    const file = files[0];
    this.setState({
      gpxFile: file || null,
      gpxData: null,
      courseName: null,
      isCourseNameEditable: false,
      error: null,
    });
    if (file) {
      this.parseGpxFile(file);
    }
  }

  onCourseNameChange = e => {
    this.setState({courseName: e.target.value});
  }

  parseGpxFile = (gpxFile) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const gpxData = parseGpx(e.target.result);
        this.setState({
          gpxData: gpxData,
          courseName: gpxData.courseName,
          isCourseNameEditable: true,
          error: null,
        });
      } catch (error) {
        console.error(error);
        this.setState({gpxData: null, isCourseNameEditable: false, error: this.getErrorText(error)});
      }
    };
    reader.readAsText(gpxFile);
  }

  handleConvertGpxForWahoo = () => {
    const {gpxData, courseName, gpxFile} = this.state;
    try {
      const {xml} = buildTcx({
        courseName: courseName || gpxData.courseName,
        track: gpxData.track,
        waypoints: gpxData.waypoints,
      });
      this.saveTcx(xml, this.getTcxFileName(gpxFile.name));
      this.setState({error: null});
    } catch (error) {
      console.error(error);
      this.setState({error: this.getErrorText(error)});
    }
  }

  getTcxFileName = (fileName) => {
    const dotLastIndex = fileName.lastIndexOf('.');
    const name = dotLastIndex === -1 ? fileName : fileName.substring(0, dotLastIndex);
    return `${name}.tcx`;
  }

  saveTcx = (xmlData, fileName) => {
    const blob = new Blob([xmlData], {type: "text/plain;charset=utf-8"});
    saveAs(blob, fileName);
  }

  render () {
    const {classes} = this.props;
    const {
      gpxData,
      courseName,
      isCourseNameEditable,
      error,
    } = this.state;

    return (
      <div className={classes.homeRoot}>
        <Paper elevation={4} className={classes.greetings}>
          <h2>{this.getI18n('title')}</h2>
          <div>
            {this.getI18n('description')}
          </div>
          <hr />
          <div>
            <input type='file' accept='.gpx' onChange={this.onFileChange} />
          </div>
          <TextField
            id="route-title-input"
            label={this.getI18n('route_title')}
            disabled={!isCourseNameEditable}
            value={courseName||''}
            onChange={this.onCourseNameChange}
          />
          {gpxData && (
            <div className={classes.summary}>
              {this.getI18n('summary')(gpxData.track.length, gpxData.waypoints.length)}
            </div>
          )}
          {error && (
            <div className={classes.error}>{error}</div>
          )}
          <div>
            <Button
              color="primary"
              variant="contained"
              disabled={!gpxData}
              onClick={this.handleConvertGpxForWahoo} >
              {this.getI18n('convert')}
            </Button>
          </div>
        </Paper>
      </div>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withStyles(styles)(Home);
